













import Vue from "vue";
export default Vue.extend({
  name: "c-text-filter",
  props: ["id", "name", "value"]
});
